import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const KYCNedir = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('kycNedir.bannerTitle')}
                path="/nordex-academy"
            />

            <div className="academy-page">
                {/* Giriş */}
                <div className="academy-intro-section py-5">
                    <div className="container">
                        <h3 className="academy-subtitle">{t('kycNedir.subtitle')}</h3>
                        <p className="academy-intro-text">{t('kycNedir.intro.p1')}</p>
                        <p className="academy-intro-text fw-bold">{t('kycNedir.intro.p2')}</p>
                        <ul className="academy-list">
                            {(t('kycNedir.intro.items', { returnObjects: true }) || []).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bölüm 1: KYC Nedir? */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNedir.section1.title')}</h2>
                        <p className="academy-section-text">{t('kycNedir.section1.p1')}</p>
                        
                        <div className="academy-highlight-box">
                            <h4>{t('kycNedir.section1.simpleTitle')}</h4>
                            <p>{t('kycNedir.section1.simpleDefinition')}</p>
                        </div>

                        <h3 className="academy-subsection-title mt-5">{t('kycNedir.section1.history.title')}</h3>
                        <p className="academy-section-text">{t('kycNedir.section1.history.p1')}</p>
                        <ul className="academy-list">
                            {(t('kycNedir.section1.history.timeline', { returnObjects: true }) || []).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bölüm 2: KYC Neden Gereklidir? */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNedir.section2.title')}</h2>
                        <p className="academy-section-text">{t('kycNedir.section2.intro')}</p>
                        
                        {(t('kycNedir.section2.reasons', { returnObjects: true }) || []).map((reason, index) => (
                            <div className="academy-step-card mb-4" key={index}>
                                <div className="step-content">
                                    <h4>{reason.title}</h4>
                                    <p>{reason.description}</p>
                                    {reason.points && (
                                        <ul>
                                            {(reason.points || []).map((point, pIdx) => (
                                                <li key={pIdx}>{point}</li>
                                            ))}
                                        </ul>
                                    )}
                                    {reason.note && (
                                        <p className="mt-2 fst-italic"><small>{reason.note}</small></p>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 3: KYC Sürecinde Neler İstenir? */}
                <div className="academy-section mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNedir.section3.title')}</h2>
                        <p className="academy-section-text">{t('kycNedir.section3.intro')}</p>
                        
                        {/* Kimlik Belgesi */}
                        <div className="academy-type-card mb-4">
                            <h4>{t('kycNedir.section3.idDocument.title')}</h4>
                            <p>{t('kycNedir.section3.idDocument.subtitle')}</p>
                            
                            <div className="mt-3">
                                {(t('kycNedir.section3.idDocument.types', { returnObjects: true }) || []).map((type, index) => (
                                    <div key={index} className="mb-3">
                                        <strong>{type.name}</strong>
                                        <ul>
                                            {(type.requirements || []).map((req, rIdx) => (
                                                <li key={rIdx}>{req}</li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>

                            <div className="academy-highlight-box  mt-3">
                                <strong>{t('kycNedir.section3.idDocument.attention.title')}</strong>
                                <ul>
                                    {(t('kycNedir.section3.idDocument.attention.items', { returnObjects: true }) || []).map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Adres Belgesi */}
                        <div className="academy-type-card">
                            <h4>{t('kycNedir.section3.addressDocument.title')}</h4>
                            <p>{t('kycNedir.section3.addressDocument.subtitle')}</p>
                            
                            <div className="mt-3">
                                <strong>{t('kycNedir.section3.addressDocument.acceptedLabel')}</strong>
                                <ul>
                                    {(t('kycNedir.section3.addressDocument.accepted', { returnObjects: true }) || []).map((doc, index) => (
                                        <li key={index}>{doc}</li>
                                    ))}
                                </ul>
                            </div>

                            <div className="mt-3">
                                <strong>{t('kycNedir.section3.addressDocument.conditionsLabel')}</strong>
                                <ul>
                                    {(t('kycNedir.section3.addressDocument.conditions', { returnObjects: true }) || []).map((cond, index) => (
                                        <li key={index}>{cond}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bölüm 4: KYC Seviyeleri */}
                <div className="academy-section mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNedir.section4.title')}</h2>
                        <p className="academy-section-text">{t('kycNedir.section4.intro')}</p>
                        
                        {/* Tablo */}
                        <div className="academy-table-wrapper">
                            <table className="academy-table">
                                <thead>
                                    <tr>
                                        <th>{t('kycNedir.section4.table.header1')}</th>
                                        <th>{t('kycNedir.section4.table.header2')}</th>
                                        <th>{t('kycNedir.section4.table.header3')}</th>
                                        <th>{t('kycNedir.section4.table.header4')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(t('kycNedir.section4.table.rows', { returnObjects: true }) || []).map((row, index) => (
                                        <tr key={index}>
                                            <td><strong>{row.level}</strong></td>
                                            <td>{row.requirements}</td>
                                            <td>{row.dailyLimit}</td>
                                            <td>{row.withdrawalLimit}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Seviye Detayları */}
                        <div className="row g-4 mt-4">
                            {(t('kycNedir.section4.levels', { returnObjects: true }) || []).map((level, index) => (
                                <div className="col-12" key={index}>
                                    <div className="academy-type-card">
                                        <h4>{level.name}</h4>
                                        <p>{level.description}</p>
                                        
                                        <div className="row mt-3">
                                            <div className="col-md-6">
                                                <strong>{t('kycNedir.section4.featuresLabel')}</strong>
                                                <ul>
                                                    {(level.features || []).map((feature, fIdx) => (
                                                        <li key={fIdx}>{feature}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>{t('kycNedir.section4.limitsLabel')}</strong>
                                                <ul>
                                                    {(level.limits || []).map((limit, lIdx) => (
                                                        <li key={lIdx}>{limit}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Bölüm 5: Veri Güvenliği */}
                <div className="academy-section mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNedir.section5.title')}</h2>
                        <p className="academy-section-text">{t('kycNedir.section5.intro')}</p>
                        
                        <h3 className="academy-subsection-title mt-4">{t('kycNedir.section5.subtitle')}</h3>
                        
                        <div className="row g-4">
                            {t('kycNedir.section5.commitments', { returnObjects: true }).map((commitment, index) => (
                                <div className="col-md-6 d-flex" key={index}>
                                    <div className="academy-advantage-card w-100">
                                        <h5>{commitment.title}</h5>
                                        <p>{commitment.description}</p>
                                        {commitment.points && (
                                            <ul className="mt-2">
                                                {(commitment.points || []).map((point, pIdx) => (
                                                    <li key={pIdx}>{point}</li>
                                                ))}
                                            </ul>
                                        )}
                                        {commitment.note && (
                                            <p className="mt-2 fst-italic"><small>{commitment.note}</small></p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="academy-highlight-box  mt-5">
                            <strong>{t('kycNedir.section5.importantNote.title')}</strong>
                            <p className="mb-0 mt-2">{t('kycNedir.section5.importantNote.text')}</p>
                        </div>
                    </div>
                </div>

                {/* Bölüm 6: SSS */}
                <div className="academy-section mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNedir.section6.title')}</h2>
                        
                        {(t('kycNedir.section6.questions', { returnObjects: true }) || []).map((qa, index) => (
                            <div className="academy-highlight-box mb-3" key={index}>
                                <h5>{qa.question}</h5>
                                <p className="mb-0">{qa.answer}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Özet */}
                <div className="academy-summary-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('kycNedir.summary.title')}</h2>
                        <p className="academy-section-text">{t('kycNedir.summary.p1')}</p>
                        <p className="academy-section-text">{t('kycNedir.summary.p2')}</p>
                        <p className="academy-section-text">{t('kycNedir.summary.p3')}</p>
                    </div>
                </div>
            </div>

            <Cta1 
            title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}/>
        </div>
    );
};

export default KYCNedir;
